import type { UseSpatiusAvatarResult } from "@/types/spatius-avatar";
import { createContext, useContext } from "react";

export const SpatiusAvatarContext = createContext<UseSpatiusAvatarResult | null>(null);

export function useOptionalSpatiusAvatarContext() {
  return useContext(SpatiusAvatarContext);
}

export function useSpatiusAvatarContext() {
  const context = useOptionalSpatiusAvatarContext();

  if (!context) {
    throw new Error("useSpatiusAvatarContext must be used within SpatiusAvatarProvider.");
  }

  return context;
}
